import React, {Component} from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CurrencyType from '../../constants/CurrencyType';
import ReactDOM from 'react-dom';
import {css} from 'react-emotion';
import currencyFormatter  from 'currency-formatter';
import {
   Row,
    Col,
    Icon,
    Grid,
    Panel,
    Table,
    PanelBody,
    PanelHeader,
    FormControl,
    PanelContainer,
    FormGroup,
    ControlLabel,
    Form,
    Well,
    InputGroup,
    Button,
    ButtonGroup,
    ButtonToolbar,
    MenuItem,
    DropdownButton,
} from '@sketchpixy/rubix';

import {getPaymentList, downloadPaymentList, getServiceRegion} from '../../api/api';
import {Link, withRouter} from 'react-router';
import moment from 'moment';
import {routeUrl} from '../routeUrl';
import styled from "styled-components";

const DatePickerDiv = styled.div`
  > div > div.react-datepicker__input-container input {
   width: 120px;
  }
`;

@withRouter
export default class PaymentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roleCountry: 'ALL',
      serviceRegions: [],
      payments: [],
      datatables: null,
      search: {
          billingKey: '',
          query: '',
          country: '',
          allDate:  false,
          dateFrom:  moment().add(-5, 'days').toDate(),
          dateTo:  moment().toDate()
      },
      searchData: {}
    };
  }

  componentDidMount() {
      let self = this;

      getServiceRegion((err, result) => {
          if (err) {
              this.props.router.push(routeUrl.login);
          } else {
              this.setState({
                  serviceRegions: result.list,
              });
          }
      });

      let datatableDom = $(ReactDOM.findDOMNode(this.refs.datatables));
      let datatables = datatableDom.addClass('nowrap')
        .DataTable({
          language: { infoFiltered: "" },
          processing: true,
          serverSide: true,
          responsive: true,
          searchDelay: 2000,
          searching: false,
          ajax : function (data, callback, settings) {
             let search = self.state.search;
             self.setState({searchData: data });

             let param = _.merge({}, data, search)

             getPaymentList(param, (err, res) => {
                 callback(res.result);
             });
          },
          columns: [
              {
                  name: 'contract.currency.currencyName',
                  data: 'contract.currency.currencyName',
                  defaultContent : ""
              },
              {
                name: 'contract.patientUser.patientDto.patientNickname',
                data: 'contract.patientUser.patientDto.patientNickname',
                defaultContent : "",
                render: function ( data, type, row, meta ) {
                    let patientNickname = row.contract.patientUser.patientDto.patientNickname
                    let patientFirstName = row.contract.patientUser.patientDto.patientFirstName
                    let patientLastName = row.contract.patientUser.patientDto.patientLastName

                    if(patientNickname === null)
                    {
                      return (patientFirstName === null ? "" : patientFirstName + " ") + (patientLastName === null ? "" : patientLastName);
                    }else{
                       return row.contract.patientUser.patientDto.patientNickname;
                    }
                    return data;
                }
              },
              {
                  name: 'paymentAmount',
                  data: 'paymentAmount',
                  defaultContent : "",
                  render: function (d, type, row) {
                      const currency = row.contract.currency.currencyName;
                      const currencyType   = CurrencyType.enumValueOf(currency);

                      const scientificNotation = Math.pow(10, currencyType.decimalScale * -1);
                      let amt  = (row.paymentAmount  - row.paymentTax) * scientificNotation;
                      return currencyFormatter.format(amt, { code: currency });
                  }
              },
              {
                  name: 'paymentTax',
                  data: 'paymentTax',
                  defaultContent : "",
                  render: function (d, type, row) {
                      const currency = row.contract.currency.currencyName;
                      const currencyType   = CurrencyType.enumValueOf(currency);

                      const scientificNotation = Math.pow(10, currencyType.decimalScale * -1);
                      let amt  = d * scientificNotation;

                      return currencyFormatter.format(amt, { code: currency });
                  }
              },
              {
                  name: 'paymentTotal',
                  data: 'paymentAmount',
                  defaultContent : "",
                  render: function (d, type, row) {
                      const currency = row.contract.currency.currencyName;
                      const currencyType   = CurrencyType.enumValueOf(currency);
                      const scientificNotation = Math.pow(10, currencyType.decimalScale * -1);
                      let amt  = d * scientificNotation;
                      return currencyFormatter.format(amt, { code: currency });
                  }
              },
              {
                  name: 'paymentStatus',
                  data: 'paymentStatus',
                  defaultContent : ""
              },
              {
                  name: 'contract.contractPgBillingKey',
                  data: 'contract.contractPgBillingKey',
                  defaultContent : ""
              },
              {
                  name: 'contract.installmentPeriod',
                  data: 'contract.installmentPeriod',
                  defaultContent : ""
              },
              {
                  name: 'createdTime',
                  data: 'createdTime',
                  defaultContent : "",
                  render: function (d, type, row) {
                      return moment.utc(d).format('YYYY-MM-DD HH:mm:ss')
                  }
              }
          ],
          rowId: 'paymentId',
          select: true
      });

      datatableDom.find('tbody').on('click', 'button',  function (event) {
        let rapaelClientId = $(event.target).data("id");
        let action = $(event.target).data("action");
      });

      this.setState({datatables: datatables});
  }

  billingKeyChangeHandler = (event) => {
      let billingKey = event.target.value;
      this.setState({ search: {...this.state.search, billingKey: billingKey} });
  };

  queryChangeHandler = (event) => {
      let query = event.target.value;
      this.setState({ search: {...this.state.search, query: query} });
   };


    countryChangeHandler = (event) => {
        this.setState({ search: {...this.state.search, country: event.target.value} });
    };


    handleDateToChange = (date) => {
      this.setState({ search: {...this.state.search, dateTo: date} });
  };
    handleAllDateChanged = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({ search: {...this.state.search, allDate: value} });
    };



  handleDateFromChange = (date) => {
      this.setState({ search: {...this.state.search, dateFrom: date} });
  };

  doSearch = (search) => {
    this.state.datatables.ajax.reload();
  };

  doDownload= () => {
    let search = this.state.search;
    let param = _.merge({}, this.state.searchData, search)
      downloadPaymentList(param, "paymentlist.xlsx");
  }

  render() {
    return (
       <PanelContainer controls={false}>
          <Panel>
            <PanelHeader>
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3>Payment list</h3>
                    <Well>
                      <Form inline>
                       <div className="row" >
                            <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                                <ControlLabel>Date</ControlLabel>
                             </div>
                             <div className="col-md-3" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                                 <div className="col-md-4" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                                     <label>
                                         All Date:
                                         <input
                                             name="allDate"
                                             type="checkbox"
                                             checked={this.state.search.allDate}
                                             onChange={this.handleAllDateChanged} />
                                     </label>
                                 </div>

                                 <DatePickerDiv className="col-md-3 datePickerWidth" style={{paddingLeft: '0px', paddingRight: '0px'}}>
                                    <DatePicker
                                        className="form-control"
                                        selected={this.state.search.dateFrom}
                                        onChange={this.handleDateFromChange}
                                        withPortal
                                        locale="en"
                                        dateFormat="yyyy/MM/dd"
                                        style={{width:'110px'}}
                                        disabled={this.state.search.allDate}/>
                                        &nbsp;&nbsp;&nbsp;
                                 </DatePickerDiv>
                                 <DatePickerDiv className="col-md-3 datePickerWidth" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                                     <DatePicker
                                         className="form-control"
                                         selected={this.state.search.dateTo}
                                         onChange={this.handleDateToChange}
                                         withPortal
                                         locale="en"
                                         dateFormat="yyyy/MM/dd"
                                         style={{width:'110px'}}
                                         disabled={this.state.search.allDate}/>
                                 </DatePickerDiv>
                             </div>
                           <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                               <ControlLabel>Country</ControlLabel>
                           </div>
                           <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                               <FormControl
                                   disabled={this.state.roleCountry === 'ALL' ? false : 'disabled'}
                                   componentClass="select"
                                   onChange={this.countryChangeHandler}
                                   value={this.state.search.country}
                                   style={{width: '120px'}}>
                                   <option value="">ALL</option>
                                   {
                                       this.state.serviceRegions.map(serviceRegion => (
                                           <option key={serviceRegion.countryId} value={serviceRegion.countryAlpha2Code}>
                                               {serviceRegion.countryAlpha3Code}
                                           </option>
                                       ))
                                   }
                               </FormControl>
                           </div>

                           <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                               <ControlLabel>Billing Key</ControlLabel>
                           </div>
                           <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                               <FormControl type="text" placeholder="Billing Key" onChange={this.billingKeyChangeHandler} style={{width:"120px"}}/>
                           </div>
                           <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                               <ControlLabel>Query</ControlLabel>
                           </div>
                           <div className="col-md-1" style={{paddingLeft: '20px', paddingRight: '0px'}}>
                               <FormControl type="text" placeholder="Query" onChange={this.queryChangeHandler} style={{width:"120px"}}/>
                           </div>

                           <div className="col-md-2">
                               <FormGroup className="pull-right">
                                   <InputGroup.Button>
                                       <Button onClick={this.doDownload} className="btn-info">
                                           <i className="glyphicon glyphicon-download fa fa-download" />
                                           Excel</Button>
                                       <Button onClick={this.doSearch}>
                                           <i className="glyphicon glyphicon-search fa fa-search" />
                                           Search
                                       </Button>
                                   </InputGroup.Button>
                               </FormGroup>
                           </div>
                        </div>
                      </Form>
                    </Well>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody style={{ padding: 0 }}>
              <Table
                ref="datatables"
                className="display"
                cellSpacing="0"
                width="100%"
                ref="datatables"
              >
                <thead>
                  <tr>
                    <th>Currency</th>
                    <th>Name</th>
                    <th>Amount</th>
                    <th>Tax</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th>Billing Key</th>
                    <th>Installment</th>
                    <th>Date</th>
                  </tr>
                </thead>
              </Table>
            </PanelBody>
          </Panel>
        </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/payment-list/Payments.js